import { useParams } from "@tanstack/react-router";
import { useEffect } from "react";

/*
 * The project the person was in last, for addresses that are not in one
 * project but need one (the former `/alerts`, docs/alerts.md "Web"). Kept in
 * this browser's localStorage; a private window may refuse it, and then the
 * first project is used.
 */

const KEY = "cs.lastProject";

/** The last project opened in this browser, if it is known. */
export function lastProjectId(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

function remember(projectId: string): void {
  try {
    localStorage.setItem(KEY, projectId);
  } catch {
    // Storage refused (private window, quota): the first project serves instead.
  }
}

/** Remembers the project of every page that is in one. */
export function useRememberProject(): void {
  const { projectId } = useParams({ strict: false });
  useEffect(() => {
    if (projectId) remember(projectId);
  }, [projectId]);
}
